import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const ChatAdminActions = createActionGroup({
  source: 'ChatAdmin',
  events: {
    'Call Customer Journey': props<{
      contextName?: string;
      isFirstCall?: boolean;
      beforeEscalation?: boolean;
    }>(),
    'Update Response': props<{
      value: ChatAdminResponse;
      isFirstCall?: boolean;
      beforeEscalation?: boolean;
    }>(),
    Escalate: emptyProps(),
    'Get Default Journey': emptyProps(),
    'Handle Chat Admin Failure': emptyProps(),
    'Load Alert Banner': props<{ alertConfig: any }>(),
  },
});
